var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNascarCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 468.6 226.1",
    height: "145px",
    width: "300px",
    viewBox: "0 0 468.6 226.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m447.6 226.1h-426.6c-11.6 0-21-9.4-21-21v-184.1c0-11.6 9.4-21 21-21h426.6c11.6 0 21 9.4 21 21v184.1c0 11.6-9.4 21-21 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m447.7 8.9h-426.7c-6.7 0-12.2 5.5-12.2 12.2v184.2c0 6.7 5.5 12.2 12.2 12.2h426.7c6.7 0 12.2-5.5 12.2-12.2v-184.2c-.1-6.8-5.5-12.2-12.2-12.2zm-431.3 93.7h435.8v8.9h-435.8zm0 74.9h435.8v8.9h-435.8zm435.8 27.8c0 2.5-2 4.6-4.6 4.6h-426.6c-2.5 0-4.6-2-4.6-4.6v-11.6h435.8zm0-110h-435.8v-74.2c0-2.5 2-4.6 4.6-4.6h426.7c2.5 0 4.6 2.1 4.6 4.6v74.2z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m102.4 128.7h-12.4l-8.8 31.6h12.5l2.2-7.8h9.8l-2.9 10.4-9.3 7.3h-17.7l-5.3-7.3 10.3-36.8 9.3-7.3h17.7l5.3 7.3-2.9 10.5h-9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m140.5 162.9-9.3 7.3h-17.7l-5.3-7.3 12.2-44.1h10l-11.6 41.6h12.4l11.6-41.6h9.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m183.5 147.6-9.2 7.2h-15.1l-4.2 15.4h-10l14.3-51.4h25l5.3 7.3zm-17-18.9-4.6 16.2h12.5l4.5-16.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m225.9 128.7h-12.5l-2.9 10.8h15l5.3 7.3-4.5 16.1-9.3 7.3h-17.8l-5.2-7.3 2.2-7.7h9.9l-1.4 5.1h12.4l3.1-10.8h-15.2l-5.2-7.3 4.5-16.1 9.3-7.3h17.7l5.2 7.3-2.2 7.7h-9.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m248.8 139.5h16.9l-2.7 10h-16.9l-3 10.8h17.9l-2.8 9.9h-27.8l14.2-51.4h27.8l-2.7 9.9h-17.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m286.5 154.9h-7.6l-4.2 15.3h-9.9l14.3-51.3h25l5.3 7.2-6 21.5-6.9 5.4 2.1 17.1h-10zm7.6-9.9 4.5-16.3h-12.5l-4.5 16.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m313.1 170.2h-9.8l14.1-51.4h10z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m338.5 139.5h16.9l-2.7 10h-16.9l-3.1 10.8h18l-2.8 9.9h-27.8l14.2-51.4h27.8l-2.7 9.9h-17.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m387.5 128.7h-12.5l-2.9 10.8h15l5.3 7.3-4.5 16.1-9.3 7.3h-17.8l-5.2-7.3 2.2-7.7h9.9l-1.4 5.1h12.4l3-10.8h-15.1l-5.2-7.3 4.5-16.1 9.3-7.3h17.7l5.2 7.3-2.2 7.7h-9.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m252.6 29.3-9.5 7.3-4.7 16.5 5.4 7.6h15.5l-3.2 11.4h-12.8l1.5-5.5h-10.1l-2.2 8 5.5 7.5h18l9.6-7.4 4.6-16.6-5.4-7.6h-15.5l3.1-11.2h12.8l-1.6 5.5h10.2l2.3-8.2-5.3-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.5 29.3-9.6 7.3-10.6 38 5.6 7.5h18l9.6-7.5 2.9-10.7h-10.1l-2.3 8.2h-12.8l9.1-32.9h12.8l-2.3 8.3h10.2l3-10.9-5.2-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.1 39.2h12.7l-4.7 17.1h-12.7zm-7.3-9.9-14.7 52.8h10.2l4.4-15.8h8.3l1.9 15.8h9.9l-2.2-18 7.2-5.8 6-21.7-5.3-7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.2 29.3-8.2 29.8-4.9-29.8h-10.1l-14.6 52.8h10.1l8.4-29.9 5 29.9h9.9l14.6-52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.6 39.2h12.8l-4.7 17h-12.8zm.1-9.9-9.5 7.2-12.7 45.5h10.2l4.4-15.8h12.8l-4.4 15.8h10.1l12.7-45.5-5.3-7.3h-18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.2 39.2h12.8l-4.7 17h-12.8zm.1-9.9-9.5 7.3-12.6 45.5h10.2l4.4-15.8h12.8l-4.4 15.8h10.2l12.6-45.5-5.3-7.2h-18.4z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m141.2 29.3-14.6 52.8h20.2l14.6-52.8z",
    fill: "#007ac2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m112.1 29.4-14.7 52.8h9.8l14.7-52.8z",
    fill: "#ef3f43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m125.9 29.4-14.7 52.8h9.8l14.6-52.8z",
    fill: "#ef3f43"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m90.6 29.4-14.7 52.8h6.1l14.6-52.8z",
    fill: "#ffd65a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m100.5 29.4-14.6 52.8h6l14.7-52.8z",
    fill: "#ffd65a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNascarCup);
export default __webpack_public_path__ + "static/media/nascar_cup.7108a6e17107025b3b33fdf63c99abff.svg";
export { ForwardRef as ReactComponent };